import { useCallback } from "react";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import AmbientBackground from "../components/AmbientBackground";
import Hero from "../components/sections/Hero";
import StatsMarquee from "../components/sections/StatsMarquee";
import Personas from "../components/sections/Personas";
import BrandLogos from "../components/sections/BrandLogos";
import Technology from "../components/sections/Technology";
import Database from "../components/sections/Database";
import Contact from "../components/sections/Contact";

export default function Deck({ lenisRef }) {
  const scrollTo = useCallback(
    (id) => {
      const target = id === "top" ? 0 : document.getElementById(id);
      if (lenisRef?.current) {
        lenisRef.current.scrollTo(target, { offset: id === "top" ? 0 : -40 });
      } else if (target && target.scrollIntoView) {
        target.scrollIntoView({ behavior: "smooth" });
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    },
    [lenisRef]
  );

  return (
    <div className="grain relative min-h-screen bg-obsidian">
      <AmbientBackground />
      <Nav onScrollTo={scrollTo} />
      <main className="relative z-10">
        <Hero onScrollTo={scrollTo} />
        <StatsMarquee />
        <BrandLogos />
        <Personas onScrollTo={scrollTo} />
        <Technology />
        <Database />
        <Contact />
      </main>
      <Footer onScrollTo={scrollTo} />
    </div>
  );
}
